export const khachHang = {
  sections: {
    list: { title: '客户' },
    general: '基本信息',
    address: '地址',
    groupNote: '客户分组与备注',
    invoiceExport: '开票信息',
    extra: '补充信息',
    invoice: '发票与税',
    idDocs: '证件',
    bank: '银行',
    meta: '统计',
    tabGeneral: '基本信息',
    tabDiaChiNhanHang: '配送信息',
    tabThongTinXuatHoaDon: '开票信息',
  },
  fields: {
    code: '客户代码',
    name: '客户名称',
    phone1: '电话 1',
    phone2: '电话 2',
    birthday: '生日',
    gender: '性别',
    email: '邮箱',
    facebook: 'Facebook',
    address: '地址',
    province: '省/市',
    area: '区域',
    ward: '坊/社',
    note: '备注',
    customerType: '客户类型',
    kenhBan: '销售渠道',
    groups: '分组',
    groupCode: '分组编码',
    groupName: '分组名称',
    nhanVienPhuTrach: '负责员工',
    maNhanVienPhuTrach: '负责员工编码',
    dinhMucCongNo: '信用额度',
    ngayCanDoiNo: '催收日期',
    ngayDoiNoCuThe: '选择日期',
    ngayDoiNoHangThang: '每月日期',
    buyerName: '购买方（发票）',
    taxCode: '税号',
    invoiceAddress: '发票地址',
    invoiceProvince: '发票省/市',
    invoiceWard: '发票坊/社',
    invoiceEmail: '发票邮箱',
    invoicePhone: '发票电话',
    citizenId: '身份证',
    passport: '护照',
    bankName: '银行',
    bankAccount: '账号',
    status: '状态',
    totalSales: '总销售额',
    totalSalesNet: '销售额（减去退货）',
    debt: '当前欠款',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: 'TT',
  },
  aria: {
    columnPicker: '选择显示列',
  },
  loai: { caNhan: '个人', congTy: '组织/个体户' },
  kenhBanLabels: {
    BAN_TRUC_TIEP: '直接',
    SHOPEE: 'Shopee',
    TIKTOK_SHOP: 'TikTok',
  },
  placeholders: {
    codeAuto: 'KH0000001',
    email: 'email@gmail.com',
    facebook: 'facebook.com/username',
    address: '输入地址',
    area: '选择省/市',
    ward: '选择坊/社',
    groups: '选择客户分组',
    loaiKhachHangKeep: '不更改',
    note: '输入备注',
    nhanVienPhuTrach: '选择负责员工',
    maNhanVienPhuTrach: '输入负责员工编码',
    dinhMucCongNo: '留空 = 不限',
    ngayCanDoiNo: '到该日期仍欠款将提醒催收',
    ngayDoiNoHangThang: '每月到该日仍欠款将提醒；当月无此日则取月末',
    ngayDoiNoHangThangChon: '选择日期',
    gender: '选择性别',
    buyerName: '输入购买方名称',
    taxCode: '输入税号',
  },
  avatar: {
    addPhoto: '添加图片',
    maxSize: '图片不得超过 2MB',
    chooseImage: '选择图片',
    pasteImage: '粘贴图片',
    pasteHint: '在框内 Ctrl+V 或点击粘贴图片',
    pasteNoImage: '剪贴板中没有图片。请复制图片或粘贴 http(s) 链接。',
    uploading: '正在上传图片…',
  },
  formActions: {
    lookupTax: '查询税号',
    lookupTaxSoon: '税号查询功能即将上线',
  },
  actions: {
    addDiaChi: '添加',
    addTtxhd: '添加公司',
  },
  values: {
    khongGioiHan: '不限',
    chuaDat: '未设置',
    hangThang: '每月{day}日',
    ngayTrongThang: '{day}日',
  },
  kieuHanDoiNo: { khong: '不设置', hangThang: '每月', ngay: '指定日期' },
  gender: { nam: '男', nu: '女' },
  status: {
    dangHoatDong: '启用',
    ngungHoatDong: '停用',
    ngungKinhDoanh: '停业',
    moKinhDoanh: '开业',
    all: '全部',
  },
  sort: {
    maKhachHang: '代码',
    tenKhachHang: '名称',
    ngayTao: '创建时间',
    trangThai: '状态',
    noHienTai: '欠款',
    tongBan: '销售额',
  },
  filter: {
    searchPlaceholder: '搜索',
    textDetailTitle: '详细筛选',
    group: '分组',
    statusSection: '状态',
    groupSection: '客户分组',
    loaiSection: '客户类型',
    debtSection: '应收状态',
    debtAll: '全部',
    debtOutstanding: '尚欠（≠ 0）',
    debtCleared: '已清（= 0）',
    genderSection: '性别',
    khuVucSection: '地区',
    khuVucPlaceholder: '地区（省/市）',
    sortSection: '排序',
    sortField: '排序字段',
    sortDir: '方向',
  },
  titles: { add: '新增客户', edit: '编辑客户', detail: '客户详情' },
  validation: {
    nameRequired: '请输入客户名称',
    hanDoiNoRequired: '请选择催收日期',
    phoneInvalid: '电话号码无效（8–15 位数字）',
    emailInvalid: '邮箱无效',
    emailHoaDonInvalid: '开票邮箱无效（多个邮箱用 ; 分隔）',
    dinhMucCongNoAm: '欠款限额不能为负数',
    phoneInvalidField: '{field}无效（8–15 位数字）',
    birthdayInvalid: '生日无效（不能是未来日期或早于 1900 年）',
    viDoInvalid: '纬度必须在 -90 到 90 之间',
    kinhDoInvalid: '经度必须在 -180 到 180 之间',
    taxCodeInvalid: '税号无效（10 或 13 位数字）',
    companyNameRequired: '请输入开票公司名称',
    subFormInvalid: '收货 / 开票信息中有无效字段',
    trungSdtTitle: '电话号码已存在',
    trungSdtMessage: '电话 {phone} 已被以下客户使用：{customers}。仍要保存该客户吗？',
  },
  messages: {
    noData: '无数据',
    loadError: '加载失败',
    loadDetailError: '无法加载详情',
    createSuccess: '已创建客户',
    updateSuccess: '已更新客户',
    deleteSuccess: '已删除客户',
    toggleSuccess: '已更新状态',
    confirmDelete: '删除客户 «{name}»？',
    confirmTitle: '确认删除',
    listSummary: '共 {count} 位客户',
    selectedCount: '已选：{count}',
    deleteSelected: '删除已选 ({count})',
    updateSelected: '更新信息',
    ngungKinhDoanhSelected: '停业 ({count})',
    bulkDeleteConfirm: '删除已选的 {count} 位客户？（逐条调用删除 API。）',
    bulkDeleteSuccess: '已删除 {count} 位客户',
    bulkDeletePartial: '已删除 {ok}/{total}，{failed} 位无法删除。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '未选择任何客户',
    bulkNgungSuccess: '已将所选客户设为停业。',
    bulkNgungPartial: '已停业 {ok}/{total}；失败 {fail}。',
    bulkNgungError: '批量停业失败',
    bulkNgungNoneSelected: '未选择任何客户',
    bulkUpdateTitle: '更新信息',
    bulkUpdateHint: '仅发送已选择的字段。留空则不上传，保持原有信息。',
    bulkUpdateSuccess: '已更新 {count} 位客户',
    bulkUpdatePartial: '已更新 {ok}/{total}，{failed} 位无法更新。',
    bulkUpdateError: '批量更新失败',
    bulkUpdateNoneSelected: '未选择任何客户',
    bulkUpdateNoField: '请至少选择一项要更新的信息',
  },
  bulkNgungDialog: {
    title: '停业',
    body: '将已选的 {count} 位客户设为停业？客户状态将变为停用。',
  },
  import: {
    description:
      '下载多工作表 Excel 模板：客户、配送信息、取税公司、银行账号。填写后上传导入。',
    success: '客户导入成功',
    failed: '客户导入失败',
    noData: '文件没有有效数据行',
    noSheet: 'Excel 文件没有任何工作表',
    wrongTemplate:
      '文件不是客户导入模板（例如选了商品导入模板）。请在此对话框下载正确模板，或到「商品」菜单导入商品。',
    sheetsHint:
      '工作表：客户 · 配送信息 · 取税公司 · 银行账号（按税号/公司名关联）。',
    menu: {
      kh: '导入客户',
      diaChi: '导入配送信息',
      cty: '导入取税公司',
      taiKhoan: '导入银行账号',
      toHop: '组合导入（客户 + 配送 + 取税公司 + 账号）',
    },
    modes: {
      kh: {
        title: '导入客户',
        description: '下载「客户」工作表模板。不创建地址 / 取税公司 / 账号。',
        success: '客户导入成功',
      },
      diaChi: {
        title: '导入配送信息',
        description: '客户编码必须已存在。每行 = 一个配送地址。',
        success: '配送信息导入成功',
      },
      cty: {
        title: '导入取税公司',
        description: '客户编码必须已存在。每行 = 一个取税/开票公司（不含账号）。',
        success: '取税公司导入成功',
      },
      taiKhoan: {
        title: '导入银行账号',
        description: '按客户上已有的税号/公司名挂接账号。',
        success: '银行账号导入成功',
      },
      ctyTaiKhoan: {
        title: '导入取税公司 + 银行账号',
        description: '两个工作表：取税公司与银行账号。客户编码必须已存在。账号按税号/公司名关联。',
        success: '公司 + 账号导入成功',
      },
      toHop: {
        title: '组合导入',
        description:
          '多工作表模板：客户 · 配送信息 · 取税公司 · 银行账号（含参考表）。创建新客户及关联数据。',
        success: '组合导入成功',
      },
    },
  },
  detailTabs: {
    generalInfo: '信息',
    diaChiLayHang: '配送信息',
    thongTinXuatHoaDon: '开票信息',
    debt: '应收',
    salesReturnHistory: '销售/退货历史',
    orderHistory: '订货历史',
  },
  expandSalesReturn: {
    hint: '销售/退货历史将在此显示。',
  },
  expandOrderHistory: {
    hint: '订货历史将在此显示。',
  },
  expandDebt: {
    hint: '应收交易记录将在此显示。',
    loading: '正在加载应收账款…',
    loadError: '无法加载应收账款',
    totalDue: '应收合计',
    totalPaid: '已收款',
    totalRemaining: '未收款',
    invoiceCount: '{count} 张发票',
    recentInvoices: '最近发票',
    viewAll: '查看全部',
    retry: '重试',
    invoiceCode: '发票编号',
    invoiceDate: '日期',
    invoiceStatus: '状态',
    amountDue: '应收',
    amountPaid: '已付',
    amountRemaining: '余额',
  },
}
